//TODO with proper logging features
function logInfo(...str) {
  if (import.meta.env.MODE === "development") console.info(str);
}

function logError(...str) {
  console.error(str);
}
export { logInfo, logError }
